<template>
  <tr
    class="event-race"
    :class="{'event-race_compact': compact}"
  >
    <td
      class="event-race__title-col"
    >
      <div class="event-race__title">
        <div class="event-race__icon" v-if="icon">
          <icon :icon-name="icon"></icon>
        </div>
        <div class="event-race__title-text">
          <h3 class="event-race__name">{{ race.n }}</h3><div class="event-race__icons">
            <div class="event-race__icons-item" v-if="race.ivr">
              <v-popover placement="top-center" trigger="hover">
                <icon class="icon color-success" icon-name="global" w="16" h="16"></icon>
                <template slot="popover">
                  <div>{{ $t('race.isOnline') }}</div>
                </template>
              </v-popover>
            </div>
            <div class="event-race__icons-item" v-if="race.nas">
              <v-popover placement="top-center" trigger="hover">
                <icon class="icon color-success" icon-name="file-done" w="16" h="16"></icon>
                <template slot="popover">
                  <div>{{ $t('race.hasFastId') }}</div>
                </template>
              </v-popover>
            </div>
          </div>
          <div
            v-if="type !== 'other'"
            class="event-race__details-sm text-sm"
            :class="{'d-lg-none': !compact}"
          >
            {{ race.dn }}
            <span v-if="raceName" v-html="' · ' + raceName"></span>
          </div>
        </div>
      </div>
    </td>
    <td class="event-race__details" v-if="type !== 'other'">
      <div class="text-sm">
        {{ race.dn }}
        <span v-if="raceName" v-html="' · ' + raceName"></span>
      </div>
    </td>

    <td class="event-race__price" v-if="type !== 'other'">
      <template v-if="!isHideParticipantCount">
        <div v-if="finished">
          <b
            class="event-race__members h3-m m-0 text-with-icon text-nowrap"
            :class="{'color-black-25': race.pc < 1}"
          >
            <icon class="icon" icon-name="user-groups" w="20" h="20"></icon>
            <span>{{ race.pc || 0 }}</span>
          </b>
        </div>
      </template>

      <temlpate v-if="!finished">
        <div
          class="event-race__cost h3-m m-0"
          :class="{
            'event-race__cost_default': registration.offlineAvailable,
            'event-race__cost_muted': !registration.offlineAvailable
            && (!registration.available || places.none || race.IsParticipantLimitReached)
          }"
        >
          <template v-if="racePrice && raceBasePrice && registration.available && !places.none">
            <b class="d-inline-block text-sm color-muted"><s>{{ raceBasePrice }} {{ currency }}</s>&nbsp;</b>&nbsp;<span>{{ racePrice }} {{ currency }}</span>
            <span v-if="showParticipationPrice" class="text-sm color-muted">/&nbsp;{{ $t('race.priceParticipant') }}</span>
          </template>
          <template v-else-if="racePrice">
            {{ racePrice }} {{ currency }}
            <span v-if="showParticipationPrice" class="text-sm color-muted">/&nbsp;{{ $t('race.priceParticipant') }}</span>
          </template>
          <template v-else>{{ $t('race.free') }}</template>
        </div>
        <template v-if="!registration.offlineAvailable">
          <!-- No places hint : BEGIN -->
          <div
            class="event-race__seats"
            v-if="!registration.notOpened && (!registration.available || places.none || race.IsParticipantLimitReached)"
          >
            <b class="color-muted d-none d-md-block">{{ $t('race.noPlaces') }}</b>
            <badge
              class="d-md-none"
              :text="$t('race.noPlaces')"
              type="muted"
            >
            </badge>
          </div>
          <!-- No places hint : END -->
          <!-- Dynamic price by date hint : BEGIN -->
          <div
            class="event-race__seats"
            v-else-if="dynamicPriceHintAvailable && race.prt === 4"
          >
            <b v-html="`${$tc('race.days', daysBeforeNewPrice || 1)} ${$tc('race.beforePriceIncrease', 'color-danger')}`"></b>
          </div>
          <!-- Dynamic price by date hint : END -->
          <!-- Dynamic price by registrations hint : BEGIN -->
          <div
            class="event-race__seats"
            v-else-if="dynamicPriceHintAvailable && race.prt === 5"
          >
            <b v-html="`${$tc('race.places', race.ph)} ${$tc('race.beforePriceIncrease', 'color-danger')}`"></b>
          </div>
          <!-- Dynamic price by registrations hint : END -->
          <!-- Few places available hint : BEGIN -->
          <div
            class="event-race__seats"
            v-else-if="!race.hapc && places.fewAvailable"
          >
            <div class="text-with-icon">
              <icon
                class="icon"
                icon-name="fire"
                w="14"
                h="14"
              />
              <b
                class="d-none d-md-block"
                v-html="$tc('race.placesLeft', places.count)"
              ></b>
              <b
                class="d-md-none"
                v-html="$tc('race.places', places.count)"
              ></b>
            </div>
          </div>
          <!-- Few places available hint : END -->
          <!-- Places count hint : BEGIN -->
          <div
            class="event-race__seats"
            v-else-if="!race.hapc && places.count"
          >
            <div
              class="d-none d-md-block"
              v-html="$tc('race.placesLeft', places.count)"
            ></div>
            <b
              class="d-md-none"
              v-html="$tc('race.places', places.count)"
            ></b>
          </div>
          <!-- Places count hint : BEGIN -->
        </template>
      </temlpate>
    </td>

    <td class="event-race__action">
      <div v-if="type === 'other'">
        <Button
          variant="ghost"
          wide
          :href="registerLink"
          target="_blank"
          :text="$t('race.choose')"
          icon-right="right"
        ></Button>
      </div>
      <div
        v-else-if="showIsMember && race.ism"
        class="rr-buttons-group rr-buttons-group_flex"
      >
        <Button
          variant="ghost"
          view="success"
          wide
          disabled-quiet
          :text="$t('race.isMember')"
          icon-right="check-bold"
          style="flex-grow: 1;"
        ></Button>
        <Button
          v-if="registration.available && !places.none && !race.dfr"
          variant="primary"
          :href="registerLink"
          target="_blank"
          text="+1"
        ></Button>
      </div>
      <div v-else>
        <Button
          v-if="isLive"
          :variant="compact ? 'ghost' : 'primary'"
          :view="compact ? null : 'danger'"
          wide
          :href="liveLink"
          target="_blank"
          :text="liveText || $t('race.liveStream')"
          :icon-right="compact ? 'right' : 'play'"
        ></Button>
        <Button
          v-else-if="registration.notOpened"
          variant="ghost"
          wide
          disabled
          :text="$t('race.registrationSoon')"
        ></Button>
        <template v-else-if="finished">
          <Button
            v-if="race.pc < 1"
            variant="ghost"
            wide
            disabled
            :text="$t('race.noResults')"
          ></Button>
          <Button
            v-else-if="race.rsc"
            variant="ghost"
            wide
            :href="resultsLink"
            target="_blank"
            :text="resultsText || $t('race.results')"
            icon-right="right"
          ></Button>
          <v-popover class="d-block" placement="top-center" trigger="hover" v-else>
            <Button
              variant="ghost"
              wide
              disabled
              :text="$t('race.results')"
            ></Button>
            <template slot="popover">
              <div v-html="$t('race.resultsNotCalculated')"></div>
            </template>
          </v-popover>
        </template>
        <Button
          v-else-if="registration.offlineAvailable"
          variant="secondary"
          wide
          v-open-modal="{ name: 'offline-reg-modal' }"
          :text="$t('race.offlineRegistration')"
        ></Button>
        <Button
          v-else-if="!registration.available || places.none || race.IsParticipantLimitReached"
          variant="ghost"
          wide
          disabled
          :text="$t('race.registrationClosed')"
        ></Button>
        <Button
          v-else
          variant="ghost"
          wide
          :href="registerLink"
          target="_blank"
          :text="registerText || $t('race.registration')"
          icon-right="right"
        ></Button>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
import Badge from '@/components/Badge.vue';
import { sportTypesMixin } from '@/assets/js/mixins';
import moment from 'moment';

export default {
  name: 'EventRace',
  components: {
    Badge,
  },
  props: {
    race: Object,
    raceDynamicInfo: Object,
    compact: Boolean,
    type: String,
    registerText: String,
    resultsText: String,
    liveText: String,
    event: Object,
    finished: Boolean,
    showIsLive: Boolean,
    scountInfo: Object,
    utcCurrentTime: String,
  },
  mixins: [sportTypesMixin],
  methods: {
    parseAtobToJson(dataBase64) {
      let dataJson;

      try {
        dataJson = window.atob(dataBase64);
      } catch (err) {
        console.error('atobError', err);
      }

      if (!dataJson) return;

      let parsedData = null;

      try {
        parsedData = JSON.parse(dataJson);
      } catch (err) {
        console.error('no valid json in base64');
      }

      return parsedData;
    },
  },
  computed: {
    isCurrentParticipant() {
      return this.race.ism;
    },
    ...mapGetters('settings', ['themeCurrency']),
    currency() {
      return this.themeCurrency;
    },
    racePrice() {
      return this.race.p;
    },
    showParticipationPrice() {
      return this.race.ShowParticipationPrice;
    },
    raceBasePrice() {
      if (this.race.hbp) {
        return null;
      }
      const bp = this.race.bp || 0;
      return bp > this.racePrice ? bp : null;
    },
    icon() {
      if (this.type === 'other') {
        return 'shoping-cart';
      }
      const code = this.race.dc;
      if (!code) {
        return null;
      }
      const discipline = this.sportTypesImages[code];
      return discipline ? discipline.icon : null;
    },
    registration() {
      const { race, raceDynamicInfo } = this;

      const isNowAfterRegDate = moment(this.utcCurrentTime).isAfter(race.rod);
      const isNowAfterRegCloseDate = moment(this.utcCurrentTime).isAfter(race.rcd);

      const status = {
        notOpened: !isNowAfterRegDate,
        closed: isNowAfterRegCloseDate,
        disabled: raceDynamicInfo.DisableRegistration,
        offlineAvailable: race.eor,
      };

      status.available = isNowAfterRegDate && !status.disabled && !status.closed;

      return status;
    },
    places() {
      const { pc } = this.race;
      const { AvailableRegistrationsCount } = this.raceDynamicInfo;

      const places = {
        count: AvailableRegistrationsCount,
        fewAvailable: false,
        none: AvailableRegistrationsCount === 0,
      };

      if (typeof AvailableRegistrationsCount === 'number' && typeof pc === 'number') {
        const total = AvailableRegistrationsCount + pc;
        const availablePercent = (AvailableRegistrationsCount / total) * 100;
        places.fewAvailable = availablePercent && availablePercent < 10;
      }

      return places;
    },
    isLive() {
      return this.showIsLive && this.raceDynamicInfo.IsLive;
    },
    registerLink() {
      const url = window.location.origin;
      const eventCode = this.$route.params.code;
      const raceCode = this.race.c || this.race.id;
      const finalLink = new URL(`${url}/${eventCode}/${raceCode}/Register`);
      const currentUrlParams = new URL(window.location).searchParams;
      const utmParams = [...currentUrlParams.entries()].filter(([param]) => param.startsWith('utm')) || [];

      if (utmParams.length > 0) {
        utmParams.forEach(([key, val]) => {
          finalLink.searchParams.append(key, val);
        });
      }

      if (this.scountInfo && this.scountInfo.races.includes(this.race.id)) {
        finalLink.searchParams.append('sessionId', this.scountInfo.dataSessionId);
      }

      return finalLink.toString();
    },
    resultsLink() {
      const eventCode = this.$route.params.code;
      const raceCode = this.race.c || this.race.id;
      return `${this.$env.Results}/event/${eventCode}/results/${raceCode}`;
    },
    liveLink() {
      const eventCode = this.$route.params.code;
      const raceCode = this.race.c || this.race.id;
      return `${this.$env.Live}/?code=${eventCode}&race=${raceCode}`;
    },
    raceName() {
      if (this.race.HideRaceDistance) return null;

      const name = this.race.d;

      if (name > 0 && name < 1) {
        return `${name * 1000}&nbsp;${this.$t('race.m')}`.replace('.', ',');
      }
      if (name >= 1) {
        return `${name}&nbsp;${this.$t('race.km')}`.replace('.', ',');
      }

      return null;
    },
    dynamicPriceHintAvailable() {
      return !this.registration.notOpened && this.registration.available && !this.places.none
        && this.raceBasePrice
        && this.race.ph && this.race.prt > 0;
    },
    daysBeforeNewPrice() {
      if (!this.race.ph) {
        return null;
      }
      const days = Math.floor((new Date(this.race.ph) - new Date()) / 1000 / 60 / 60 / 24);
      return days > 0 ? days : null;
    },
    showIsMember() {
      return !this.finished && !this.isLive;
    },

    isHideParticipantCount() {
      return this.race.HideParticipantCount;
    },
  },
};
</script>

<style lang="scss" scoped>
  .event-race {
    border-radius: 4px;

    td {
      padding: 12px 12px;
      vertical-align: middle;

      @media (max-width: breakpoint(md, max)) {
        padding-top: 1rem;
        padding-bottom: 1rem;

        &:first-child {
          padding-top: 12px;
        }

        &:last-child {
          padding-bottom: 12px;
        }
      }
    }

    @media (max-width: breakpoint(md, max)) {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 12px;
    }

    &__title-col {
      max-width: 300px;

      @media (max-width: breakpoint(md, max)) {
        width: 100%;
        max-width: 100%;

        &_half {
          width: 55%;
          padding-right: 0 !important;
        }
      }
    }

    &__title {
      display: flex;
      align-items: center;
    }

    &__title-text {
      flex: 1 1 100%;
    }

    &__icon {
      flex: 0 0 auto;
      width: 32px;
      height: 32px;
      color: $color-black-45;
      margin-right: 16px;

      svg {
        display: block;
      }

      @media (min-width: breakpoint(md)) {
        margin-left: 8px;
      }
    }

    &__name {
      display: inline;
      vertical-align: middle;
      flex: 1 1 auto;
      min-width: 0;
      @include text-lg;
      font-weight: $font-weight-semibold;
      margin: 0 8px 0 0;
      word-break: break-word;

      @media (min-width: breakpoint(md)) {
        @include text-lg;
      }
    }

    &__icons {
      display: inline-block;
      vertical-align: middle;
      font-size: 0;
      margin-right: -4px;
    }

    &__icons-item {
      display: inline-block;
      vertical-align: middle;
      margin-right: 4px;

      .v-popover {
        display: block;
      }
    }

    &__price {
      text-align: right;

      @media (max-width: breakpoint(md, max)) {
        width: 100%;
        text-align: center;
        border-top: 1px solid $color-black-15;
      }
    }

    &__seats {
      font-size: 12px;
      line-height: 1.5em;
      white-space: nowrap;
      margin-top: 0.25rem;
    }

    &__cost {
      color: $color-primary;
      font-weight: $font-weight-bold;
      white-space: nowrap;

      > * {
        vertical-align: middle;
      }

      &_default {
        color: inherit;
      }

      &_muted {
        color: $color-black-25;
      }
    }

    &__members {

      @media (max-width: breakpoint(md, max)) {
        @include text-lg;

        .icon {
          width: 16px;
          height: 16px;
        }
      }
    }

    &__details {
      min-width: 100px;

      @media (max-width: breakpoint(lg, max)) {
        display: none;
      }

      .event-race_compact & {
        display: none;
      }
    }

    &__details-sm {
      margin-top: 0.25rem;
    }

    &__action {
      text-align: right;
      width: 1px;
      white-space: nowrap;

      @media (max-width: breakpoint(md, max)) {
        width: 100%;
        padding-top: 0 !important;
      }

      .rr-button {
        white-space: nowrap;

        &_secondary {
          background-color: transparent;
        }
      }
    }
  }
</style>
